import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Download, Loader2, Lock } from "lucide-react";
import { downloadPost, blobErrorDetail } from "@/lib/downloadPost";

/**
 * Export-Button mit Dialog: optional (oder Pflicht) Passwort → AES-verschlüsseltes ZIP, sonst CSV.
 */
export function ZefixExportButton({ url, body = {}, label = "CSV exportieren", requirePassword = false, size = "sm", variant = "outline", testId = "zefix-export-btn", disabled = false }) {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (requirePassword && pw.length < 8) {
      toast.error("Passwort mit mindestens 8 Zeichen erforderlich");
      return;
    }
    setBusy(true);
    try {
      const name = await downloadPost(url, { ...body, password: pw || undefined });
      toast.success(`${name} heruntergeladen${pw ? " (AES-256 verschlüsselt)" : ""}`);
      setOpen(false);
      setPw("");
    } catch (e) {
      toast.error(await blobErrorDetail(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button type="button" size={size} variant={variant} onClick={() => setOpen(true)} disabled={disabled} data-testid={testId}>
        <Download className="h-4 w-4 mr-1.5" /> {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`${testId}-dialog`}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Lock className="h-4 w-4" /> {label}</DialogTitle>
            <DialogDescription>
              {requirePassword
                ? "Die Datei enthält Zugangsdaten und wird als AES-256-verschlüsseltes ZIP gespeichert. Passwort ist Pflicht."
                : "Optional ein Passwort setzen – dann wird die CSV als AES-256-verschlüsseltes ZIP geliefert (öffnen mit 7-Zip, WinRAR, Keka). Ohne Passwort: normale CSV."}
            </DialogDescription>
          </DialogHeader>
          <div>
            <Label htmlFor={`${testId}-pw`}>Passwort {requirePassword ? "(Pflicht, min. 8 Zeichen)" : "(optional)"}</Label>
            <Input id={`${testId}-pw`} type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="••••••••" data-testid={`${testId}-password`} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Abbrechen</Button>
            <Button onClick={run} disabled={busy} data-testid={`${testId}-confirm`}>
              {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Download className="h-4 w-4 mr-1.5" />} Herunterladen
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
